import { render } from "./StreamsManageVodEpisodes.vue?vue&type=template&id=ccf8fe22"
import script from "./StreamsManageVodEpisodes.vue?vue&type=script&setup=true&lang=js"
export * from "./StreamsManageVodEpisodes.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/StreamsDash/StreamsManageVodEpisodes.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ccf8fe22"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ccf8fe22', __exports__)) {
    api.reload('ccf8fe22', __exports__)
  }
  
  module.hot.accept("./StreamsManageVodEpisodes.vue?vue&type=template&id=ccf8fe22", () => {
    api.rerender('ccf8fe22', render)
  })

}


export default __exports__